import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f3a323d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal is-active centered"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_3 = { class: "modal-card" }
const _hoisted_4 = { class: "modal-card-head" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "is-flex is-flex-shrink-0" }, null, -1))
const _hoisted_6 = { class: "modal-card-title is-title-shrink" }
const _hoisted_7 = { class: "modal-card-body" }
const _hoisted_8 = {
  key: 0,
  class: "failed-unlock"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "modal-card-foot is-justify-content-flex-end" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("header", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$gettext("Authentication")), 1),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancelInput()))
            })
          ]),
          _createElementVNode("section", _hoisted_7, [
            (_ctx.state === 'failedUnlock')
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.$gettext("Failed authentication. Please try again.")), 1))
              : _createCommentVNode("", true),
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.handler.Ui.Challenge.name), {
              handler: _ctx.handler,
              state: _ctx.state,
              onSubmitInput: _ctx.submitInput
            }, null, 40, ["handler", "state", "onSubmitInput"]))
          ]),
          _hoisted_9
        ])
      ]))
    : _createCommentVNode("", true)
}